exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-card[data-v-50697f2d] {\n  width: 320px;\n  margin: 4px;\n  display: inline-block;\n  vertical-align: top;\n}\nlabel[data-v-50697f2d] {\n  font-weight: 500;\n}\n.title[data-v-50697f2d] {\n  outline: none;\n  border: none;\n}\n.card-icon[data-v-50697f2d] {\n  background: #384553 !important;\n}\n", ""]);

// exports
